import { Reducer } from "redux";
import { AdminErrorListResponseData } from "../../service/api-response/AdminFormErrorResponse";
import { PromotionCodeListItem } from "../../service/api-response/PromotionCodesSuccessResponse";
import * as actions from "./promotionCodeActions";

export interface PromotionCodeState {
  organization: {
    [orgKeyName: string]: undefined | PromotionCodeListItem[];
  };
  hasNextPage: {
    [orgKeyName: string]: undefined | boolean;
  };
  isLoadingPromotionCodeList: {
    [orgKeyName: string]: undefined | boolean;
  };
  isLoadingPromotionCode: {
    [orgKeyName: string]: undefined | boolean;
  };
  isUpserting: boolean;
  promotionCode: {
    [orgKeyName: string]: undefined | any;
  };
  upsertErrors: AdminErrorListResponseData | undefined;
}

const initialState: PromotionCodeState = {
  organization: {},
  isLoadingPromotionCodeList: {},
  isLoadingPromotionCode: {},
  hasNextPage: {},
  isUpserting: false,
  upsertErrors: undefined,
  promotionCode: {},
};

type SupportedActions =
  | actions.ListPromotionCodesAction
  | actions.ListPromotionCodesFailAction
  | actions.ListPromotionCodesSuccessAction;

export const promotionCodeReducer: Reducer<
  PromotionCodeState,
  SupportedActions
> = (state = initialState, action): PromotionCodeState => {
  switch (action.type) {
    case actions.LIST_PROMOTION_CODES: {
      let newState = {
        ...state,
        isLoadingPromotionCodeList: {
          ...state.isLoadingPromotionCodeList,
          [action.organization]: true,
        },
        hasNextPage: {
          ...state.hasNextPage,
          [action.organization]: true,
        },
      };

      if (action.page === 1) {
        newState.organization[action.organization] = [];
      }

      return newState;
    }
    case actions.LIST_PROMOTION_CODES_FAIL: {
      return {
        ...state,
        isLoadingPromotionCodeList: {
          ...state.isLoadingPromotionCodeList,
          [action.organization]: false,
        },
      };
    }
    case actions.LIST_PROMOTION_CODES_SUCCESS: {
      return {
        ...state,
        organization: {
          ...state.organization,
          [action.organization]: [
            ...(state.organization[action.organization] || []),
            ...action.data,
          ],
        },
        isLoadingPromotionCodeList: {
          ...state.isLoadingPromotionCodeList,
          [action.organization]: false,
        },
        hasNextPage: {
          ...state.hasNextPage,
          [action.organization]: !!action.data.length,
        },
      };
    }
    default: {
      return state;
    }
  }
};
